import React, { useEffect, useRef } from "react";

import CircularLoader from "@common/styles/components/circularLoader";

import "./WPLoader.scss";

const WPLoader = ({ loadingMsg, horizontal, isFocus = true }) => {
  const loaderRef = useRef(null);

  useEffect(() => {
    if (loaderRef.current && isFocus) {
      loaderRef.current.focus();
    }
  }, [isFocus]);

  return (
    <div className='wp-loader-container' data-test-id='wp-loader' tabIndex='-1' ref={loaderRef}>
      <div className={horizontal ? "horizontal" : ""}>
        <CircularLoader />
        {loadingMsg && <div className='loading-text'>{loadingMsg}</div>}
      </div>
    </div>
  );
};

export default WPLoader;
